/* src/app/app-menu/app-menu.component.css */
:host ::ng-deep .p-select-option:hover,
:host ::ng-deep .p-dropdown-item:hover {
  background: #efefef !important;
  color: #000 !important;
}
:host ::ng-deep .p-select-option.p-focus,
:host ::ng-deep .p-dropdown-item.p-highlight {
  background: #efefef !important;
  color: #000 !important;
}
.obcineMenu {
  display: flex;
  align-items: center;
  gap: 40px;
}
.refreshIcon {
  color: gray;
  font-size: 24px;
  cursor: pointer;
}
/*# sourceMappingURL=app-menu.component.css.map */
